<template>
  <Container class="max-md:px-0">
    <div class="bg-gray-10 max-md:px-4">
      <div class="mx-auto flex max-w-screen-lg flex-col py-6 lg:py-44">
        <slot />
      </div>
    </div>
  </Container>
</template>
